import {Link, withRouter} from 'react-router-dom'
import Cookies from 'js-cookie'
import CartContext from '../../context/CartContext'

import websiteLogo from '../../assets/Website-Logo.png'
import homeIcon from '../../assets/nxt-trendz-home-icon.png'
import productsIcon from '../../assets/nxt-trendz-products-icon.png'
import cartIcon from '../../assets/nxt-trendz-cart-icon.png'
import logoutIcon from '../../assets/nxt-trendz-log-out-img.png'

import './index.css'

const Header = props => {
  const onClickLogout = () => {
    const {history} = props
    Cookies.remove('jwt_token')
    history.replace('/login')
  }

  const renderCartItemsCount = () => (
    <CartContext.Consumer>
      {value => {
        const {cartList} = value
        const cartItemsCount = cartList.length
        return cartItemsCount > 0 ? (
          <span className="cart-count-badge">{cartList.length}</span>
        ) : null
      }}
    </CartContext.Consumer>
  )

  return (
    <nav className="nav-header">
      <div className="nav-content">
        <div className="nav-bar-mobile-logo-container">
          <Link to="/">
            <img className="website-logo" src={websiteLogo} alt="rk shopping hub logo" />
          </Link>
          <button type="button" className="nav-mobile-btn" onClick={onClickLogout}>
            <img src={logoutIcon} alt="nav logout" className="nav-bar-img" />
          </button>
        </div>
        
        <div className="nav-bar-large-container">
          <Link to="/">
            <img className="website-logo" src={websiteLogo} alt="rk shopping hub logo" />
          </Link>
          <ul className="nav-menu">
            <li className="nav-menu-item"><Link to="/" className="nav-link">Home</Link></li>
            <li className="nav-menu-item"><Link to="/products" className="nav-link">Products</Link></li>
            <li className="nav-menu-item">
              <Link to="/cart" className="nav-link">Cart {renderCartItemsCount()}</Link>
            </li>
          </ul>
          <button type="button" className="logout-desktop-btn" onClick={onClickLogout}>Logout</button>
        </div>
      </div>
      
      <div className="nav-menu-mobile">
        <ul className="nav-menu-list-mobile">
          <li className="nav-menu-item-mobile">
            <Link to="/"><img src={homeIcon} alt="nav home" className="nav-bar-img" /></Link>
          </li>
          <li className="nav-menu-item-mobile">
            <Link to="/products"><img src={productsIcon} alt="nav products" className="nav-bar-img" /></Link>
          </li>
          <li className="nav-menu-item-mobile">
            <Link to="/cart"><img src={cartIcon} alt="nav cart" className="nav-bar-img" />{renderCartItemsCount()}</Link>
          </li>
        </ul>
      </div>
    </nav>
  )
}

export default withRouter(Header)